<template>
    <v-row no-gutters>
        <v-col cols="12" align="center">
            <v-card width="90%" class="containerBorder mt-3" >
                <v-data-table hide-default-footer :items-per-page="-1" height="700" :headers="header"
                    :items="departments" fixed-header class="mb-8">
                    <template v-slot:header.departmentName="{ header }">
                        <div class="my-5">{{ header.text }}</div>
                    </template>
                    <template v-slot:item.departmentName="{ item }">
                        <div class="my-7 text-subtitle-1 font-weight-bold">{{ item.departmentName }}</div>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
export default {
    name: "department",
    data() {
        return {
            departments: [
                { departmentName: 'Pretrial Services Program Manager', contactName: 'Dominic Martinez', contactNumber: '(575)-758-3173 Ext. 616', email: 'taoddjm@nmcourts.gov' },
                { departmentName: 'Program Manager - Taos County Recovery Court and Family Violence Court', contactName: 'Hannah Smith', contactNumber: '(575)-758-3173 Ext. 620', email: 'taodhls@nmcourts.gov' },
                { departmentName: 'Pretrial Services Officer 1', contactName: 'John Vaughn', contactNumber: '(575)-758-3173 Ext. 640', email: ' taodjcv@nmcourts.gov' },
                { departmentName: 'Surveillance Officer - Taos County Recovery Court', contactName: 'Marcos Martinez', contactNumber: '(575)-758-3173 Ext. 645', email: 'taodmam@nmcourts.gov' },
                { departmentName: 'Program Specialist - Taos County Recovery Court', contactName: 'Sivreana Gurule', contactNumber: '(575)-758-3173 Ext. 642', email: 'taodsct@nmcourts.gov' },
                { departmentName: 'Surveillance Officer - Taos County Recovery Court and Family Violence Court', contactName: "Victoria 'Tori' Valle", contactNumber: '(505)-758-3173 Ext. 637', email: 'taodvlv@nmcourts.gov' },
                { departmentName: 'Pretrial Services Officer 1 - Colfax County Recovery Court', contactName: 'Angel Bacca', contactNumber: '(575)-445-5584 Ext. 708', email: 'ratdakb@nmcourts.gov' }
            ],
            header: [
                {
                    text: "Department Name",
                    align: "start",
                    value: "departmentName",
                    width: "650",
                    sortable: false,
                    class: "text-h6 font-weight-black text-decoration-underline",
                },
                {
                    text: "Department Contact Name",
                    align: "start",
                    value: "contactName",
                    width: "300",
                    sortable: false,
                    class: "text-h6 font-weight-black text-decoration-underline",
                },
                {
                    text: "Contact Number",
                    align: "center",
                    value: "contactNumber",
                    sortable: false,
                    class: "text-h6 font-weight-black text-decoration-underline",
                },
                {
                    text: "Email",
                    align: "center",
                    value: "email",
                    width: "300",
                    sortable: false,
                    class: "text-h6 font-weight-black text-decoration-underline",
                }
            ],
        }
    },
    mounted() {
        console.log('departments: ', this.departments)
    }
}
</script>